import React from "react";
import { Line, Pie } from "react-chartjs-2";
import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend,
	ArcElement,
} from "chart.js";
import PropTypes from "prop-types";

ChartJS.register(
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	ArcElement,
	Title,
	Tooltip,
	Legend
);
function ChartJsChart({ data, chartType, height }) {
	return (
		<div className="chart">
			{chartType === "pieChart" ? (
				<Pie
					data={data}
					options={{
						plugins: {
							legend: false,
						},
					}}
				/>
			) : (
				<Line
					data={data}
					height={height}
					options={{
						plugins: {
							legend: false,
						},
						scales: {
							y: {
								display: false,
							},
							x: {
								display: false,
							},
						},
					}}
				/>
			)}
		</div>
	);
}

ChartJsChart.defaultProps = {
	type: "",
	chartData: {},
	height: "",
};
ChartJsChart.propTypes = {
	type: PropTypes.string,
	chartData: PropTypes.instanceOf(Object),
	height: PropTypes.string,
};
export default ChartJsChart;
